<template>
	<div>
		<div class="bgBox custom-tree-container">
			<div class="block" v-loading="loading">
				<div class="doctorPage managerPlan">
					<div class="selectSearch">
						<el-input size="small" placeholder="请输入区域名称进行搜索" v-model="filterText"></el-input>
					</div>
				</div>
				<el-tree :data="regionList" node-key="id" ref="tree" default-expand-all :expand-on-click-node="false" :filter-node-method="filterNode">
					<span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
						<span>{{ node.label }}</span>
						<div v-show="data.del">
							<i @click="append(data)" v-if="node.label == '全国'" class="padding_5 textColorYellow el-icon-document-add"></i>
							<i @click="edit(data)" class="padding_5 textColorBlue el-icon-edit"></i>
							<i  v-if="node.label != '全国'" @click="remove(node, data)" class="padding_5 textColorRed el-icon-delete"></i>
						</div>
					</span>
				</el-tree>
				<el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal='false' width="60%" class="scrollbar exportFrom dialogFrom">
					<el-form label-width='100px' class="qcFrom dialogScoped" ref="setExportFrom" :rules="rules" distinguishCancelAndClose :model="exportFrom">
						<el-row>
							<el-col :span="24">
								<el-form-item label="状态">
									<div class="exportTab marr20">
										<div class="sliderScreeningR">
											<a href="javascript:;" @click="seachTab(1)" :class="exportFrom.Enable?'active':''">启用</a>
											<a href="javascript:;" @click="seachTab(0)" :class="!exportFrom.Enable?'active':''">禁用</a>
										</div>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24" v-if="isPid">
								<el-form-item label="父级名称" prop="ParentName">
									<span class="colwhite">{{exportFrom.ParentName}}</span>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="管理员" prop="UserGuids">
									<el-select size="small" class="roleRadius" @change="$forceUpdate()" v-model="exportFrom.UserGuids" multiple filterable remote reserve-keyword :remote-method="remoteMethod" style="width:240px" placeholder="请填写管理员">
										<el-option v-for="item in userList" :key="item.UserGuid" :label="item.Name" :value="item.UserGuid">
										<span>{{item.Name}}</span>
										<span class="rt">{{item.LoginId}}</span>
										</el-option>
									</el-select> <el-button type="primary" class="marl10" size="mini" @click="addRegion()">添加</el-button>
									<el-table class="qcTable mart10" :data="regionUsersList.Users" max-height="130">
										<el-table-column prop="Name" label="姓名" min-width="100"></el-table-column>
										<el-table-column prop="Mobile" label="手机号" min-width="100"></el-table-column>
										<el-table-column prop="" label="操作" width="180">
											<template slot-scope="scope">
												<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
											</template>
										</el-table-column>
									</el-table>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="区域名称" prop="Name">
									<el-input size="small" style="width:240px" v-model="exportFrom.Name" placeholder="请填写区域名称"></el-input>
								</el-form-item> 
							</el-col>
							<el-col :span="24">
								<el-form-item label="区域类型" prop="RegionType">
									<el-select size="small" v-model="exportFrom.RegionType" class="roleRadius" style="width:240px" placeholder="请选择区域类型">
										<el-option label="区域" :value="2"></el-option>
										<el-option label="省或直辖市" :value="3"></el-option>
										<el-option label="市" :value="4"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="排序" prop="Sort">
									<el-input size="small" style="width:240px" v-model="exportFrom.Sort" placeholder="请填写排序"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div class="dialog-footer mart10" align="center">
						<el-button type="primary" @click="preservation()">保 存</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import axios from '@/js/api'
	export default {
		data() {
			return {
				del: false,
				filterText: '',
				dialogVisible: false,
				exportFrom: {
					  "RegionGuid": "",
					  "Name": "",
					  "ParentGuid": "",
					  "Enable": 1,
					  "Sort": 0,
					  "RegionType": 2,
					  "UserGuids": '',
					  "IsDeleted": true,
					  "ParentName":""
				},
				title: '新增区域信息',
				rules: {
					Name: [{
						required: true,
						message: '请输入区域名称',
						trigger: 'blur'
					}],
					RegionType: [{
						required: true,
						message: '请选择区域类型',
						trigger: 'change'
					}]
				},
				isPid:true,
				userList:[]
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading']),
			...Vuex.mapState('admin', ['regionList','regionUsersList'])
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		created() {
			this.remoteMethod('')
		},
		methods: {
			...Vuex.mapMutations('admin', ['setLoading']),
			...Vuex.mapActions('admin', ['GetRegionList','GetRegionUsers','AddRegionUser','DeleteRegionUser']),
			addRegion(){
				let _this = this;
				this.AddRegionUser({
				  "RegionGuid": _this.exportFrom.RegionGuid,
				  "UserGuids": _this.exportFrom.UserGuids
				}).then(res=>{
					_this.exportFrom.UserGuids = '';
				})
			},
			delterClick(row){
				let _this = this;
				this.$confirm('确定删除该管理员吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.DeleteRegionUser({
					  "RegionGuid": _this.exportFrom.RegionGuid,
					  "UserGuids": [row.UserGuid]
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 中心管理员
			remoteMethod(query) {
				this.GetRegionList();
				// 获取医生列表
				axios.ajaxGet('get', axios.Api.api.user.GetList,{
					keyword:query,
					pageIndex:1,
					pageCount:999999
				}).then(res => {
					this.userList = res.data.Users;
				})
			},
			// 启用禁用
			seachTab(type) {
				this.exportFrom.Enable = type;
			},
			clearExportFrom(){
				this.exportFrom ={
					 "RegionGuid": "",
					 "Name": "",
					 "ParentGuid": "",
					 "Enable": 1,
					 "Sort": 0,
					 "RegionType": 2,
					 "UserGuids": "",
					 "IsDeleted": true,
					 "ParentName":""
				}
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			mouseenter(data) {
				this.$set(data, 'del', true)
			},
			mouseleave(data) {
				this.$set(data, 'del', false)
			},
			// 新增
			append(data) {
				this.editList('新增区域信息',data)
				let datas = JSON.parse(JSON.stringify(data));
				this.clearExportFrom();
				this.exportFrom.ParentGuid = data.UniqueId;
			},
			// 编辑
			edit(data) {
				this.editList('编辑区域信息',data)
				this.GetRegionUsers({regionGuid:data.UniqueId});
				let datas = JSON.parse(JSON.stringify(data));
				this.exportFrom = datas;
				// let userGuids = [];
				// this.exportFrom.Users.forEach(item=>{
				// 	userGuids.push(item.UserGuid)
				// })
				// this.exportFrom.UserGuids = userGuids;
				this.exportFrom.RegionGuid = data.UniqueId;
				this.exportFrom.ParentName = '全国';
			},
			editList(title,data,type){
				this.dialogVisible = true;
				this.title = title;
				this.isPid = data.Name == '全国'?false:true
			},
			// 增删改的请求
			createOrUpdateModule() {
				let _this = this;
				_this.setLoading(true);
				_this.exportFrom.RegionGuid =_this.exportFrom.UniqueId;
				_this.exportFrom.UserGuids = null;
				axios.ajaxPost('post', axios.Api.api.admin.createorupdate,_this.exportFrom).then(res => {
					if (res.data.StatusCode == 200) {
						_this.GetRegionList();
						_this.dialogVisible = false;
						_this.$message.success('保存成功');
						_this.setLoading(false);
					}
				})
			},
			// 保存
			preservation(){
				let _this = this;
				this.$refs.setExportFrom.validate((valid) => {
					if (valid) {
						_this.createOrUpdateModule()
					} else {
						return false;
					}
				})
			},
			// 删除
			remove(node, data) {
				let _this = this;
				this.$confirm('是否确定此区域(此区域下的所有子区域都将被删除)？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let datas = JSON.parse(JSON.stringify(data));
					_this.exportFrom = datas;
					_this.exportFrom.RegionGuid = datas.UniqueId;
					_this.exportFrom.IsDeleted = true;
					_this.setLoading(true);
					axios.ajaxPost('post', axios.Api.api.admin.DeleteRegion,_this.exportFrom).then(res => {
						if (res.data.StatusCode == 200) {
							_this.GetRegionList();
							_this.dialogVisible = false;
							_this.$message.success('删除成功');
							_this.setLoading(false);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	};
</script>
<style scoped>
/* 	.exportTab .sliderScreeningR a {
		background: #282b32;
	} */

	.exportTab .sliderScreeningR .active {
		background: #248AFD !important;
	}

	.custom-tree-container >>> .el-tree-node__expand-icon {
		position: unset !important;
	}

	.padding_5 {
		font-size: 16px;
		padding: 0 5px;
	}

	.el-icon-document-add {
		padding-left: 10px;
	}

	
	.dialogScoped >>> .el-select__tags{
		max-width: 95% !important;
	}
	.dialogFrom .roleRadius >>> .el-input__inner{
		border-radius: 6px;
	}
	.dialogFrom >>> .el-table thead td,.dialogFrom >>> .el-table thead th{
		line-height: initial !important;
	}
	.dialogFrom >>> .el-table tbody td,.dialogFrom >>> .el-table tbody th{
		padding: 2px 0 !important;
	}
	.dialogFrom >>> .el-table thead td, .dialogFrom >>> .el-table thead th{
		padding: 2px 0 !important;
	}
	.dialogFrom .el-form-item{
		margin-bottom: 10px !important;
	}
</style>

